export const referrals = {
  menu: {
    label: "Invita e guadagna",
    badge: "Guadagna",
  },
  welcomeCard: {
    title: "Il tuo piano può diventare gratis",
    desc: "Invita altri host e guadagna una parte di tutto quello che pagano, per sempre.",
  },
  page: {
    loading: "Caricamento dei tuoi inviti…",
    previewNotice: "Anteprima con dati di esempio. I tuoi inviti reali appariranno qui quando il programma sarà attivo.",
  },
  hero: {
    title: "Invita altri host e usa WACheckin gratis",
    subtitle: "Per ogni host che si abbona con il tuo link, guadagni il {percent}% di tutto quello che paga, ogni mese e per sempre. Il tuo collega parte con il {friendPercent}% di sconto.",
    personal: "Il tuo piano costa {price} al mese. Con {count} invitati come te, non paghi più.",
    personalGeneric: "Con {count} host come te che pagano, il tuo piano diventa gratis.",
  },
  rewards: {
    youGet: "Tu ricevi",
    youGetBig: "{percent}% di ogni pagamento",
    youGetSmall: "da ogni host che inviti, ogni mese e per sempre",
    friendGets: "Il tuo collega riceve",
    friendGetsBig: "{percent}% di sconto",
    friendGetsSmall: "sui primi {months} mesi",
    example: "Se inviti un host con {units} appartamenti, guadagni circa {amount} all'anno finché resta con noi.",
  },
  welcomeOffer: {
    title: "Il tuo regalo di benvenuto",
    text: "{name} ti ha invitato su WACheckin: hai il {percent}% di sconto sui primi {months} mesi. Si applica quando ti abboni.",
  },
  share: {
    title: "Il tuo link di invito",
    codeLabel: "Il tuo codice",
    copy: "Copia link",
    copied: "Copiato",
    whatsapp: "WhatsApp",
    invite: "Invia via email",
    more: "Altro",
    message: "Ti consiglio WACheckin: lo uso per il check-in online, i messaggi agli ospiti e per collegare Booking e Airbnb, e mi fa risparmiare molto tempo. Con il mio link hai il {percent}% di sconto sui primi {months} mesi: {link}",
    emailSubject: "Il {percent}% di sconto su WACheckin con il mio link",
  },
  invite: {
    title: "Invita via email",
    subtitle: "Invieremo al tuo collega un invito personale con il tuo link e il suo sconto del {percent}%.",
    emailLabel: "Email del tuo collega",
    emailPlaceholder: "nome@azienda.com",
    languageLabel: "Lingua dell'email",
    cancel: "Annulla",
    send: "Invia invito",
    sending: "Invio in corso…",
    successTitle: "Invito inviato!",
    successDesc: "Abbiamo inviato il tuo invito a {email}.",
    another: "Invita un altro collega",
    close: "Chiudi",
    errors: {
      invalidEmail: "Inserisci un indirizzo email valido.",
      selfInvite: "Non puoi inviare l'invito al tuo stesso indirizzo email.",
      alreadyInvited: "Hai già invitato questo indirizzo di recente. Potrai riprovare tra qualche giorno.",
      dailyLimit: "Hai raggiunto il limite di inviti di oggi. Riprova domani.",
      tooFast: "Troppi tentativi di seguito. Attendi un minuto e riprova.",
      generic: "Non è stato possibile inviare l'invito. Riprova.",
    },
  },
  message: {
    title: "Messaggio pronto da condividere",
    hint: "Incollalo nei tuoi gruppi di host, forum o social. Funziona meglio con una frase tua.",
    copy: "Copia messaggio",
  },
  how: {
    title: "Come funziona",
    stepLabel: "Passo {n}",
    step1Title: "Condividi il tuo link",
    step1Desc: "Su WhatsApp, via email o nei tuoi gruppi di host.",
    step2Title: "Il tuo collega si abbona con lo sconto",
    step2Desc: "Si registra con il tuo link e parte con il {percent}% di sconto.",
    step3Title: "Tu guadagni ogni mese",
    step3Desc: "Il {percent}% di ogni pagamento diventa tuo credito, per sempre. Il primo conta dopo {days} giorni.",
  },
  results: {
    title: "I tuoi risultati",
    celebrate: "Hai guadagnato {amount} finora.",
    coverage: "I tuoi invitati coprono già il {percent}% del tuo piano",
    coverageFree: "Il tuo piano è già gratis",
    coverageHint: "Il tuo piano costa {price} al mese e i tuoi invitati ti fanno guadagnare {earning} al mese.",
  },
  stats: {
    invited: "Invitati",
    subscribed: "Abbonati",
    monthlyEarning: "Guadagni al mese",
    creditAvailable: "Credito disponibile",
    creditEarned: "{amount} guadagnati in totale",
    creditHint: "Scalato automaticamente dalla prossima fattura",
  },
  list: {
    title: "I tuoi inviti",
    colName: "Account",
    colDate: "Registrazione",
    colStatus: "Stato",
    colReward: "Quanto guadagni",
    empty: "Non hai ancora invitato nessuno. Il primo host che si abbona con il tuo link ti fa già guadagnare credito ogni mese.",
  },
  status: {
    registered: "Registrato",
    subscribed: "Abbonato",
    rewarded: "Attivo",
    canceled: "Disdetto",
    rejected: "Non idoneo",
  },
  reward: {
    waiting: "In attesa del primo pagamento",
    startsOn: "Inizi a guadagnare il {date}",
    earning: "{monthly} al mese, {earned} in totale",
    earningNoPlan: "{earned} in totale",
    canceled: "{earned} guadagnati",
  },
  reasons: {
    duplicate: "Account duplicato",
    selfReferral: "Autoinvito",
  },
  faq: {
    title: "Domande frequenti",
    howMuchQ: "Quanto guadagno?",
    howMuchA: "Il {percent}% di tutto quello che paga ogni host che inviti (imposte escluse), ogni mese e per sempre, senza limite di inviti. Se paga {price} al mese, guadagni circa {amount} ogni mese.",
    whenQ: "Quando lo ricevo?",
    whenA: "Ogni volta che il tuo invitato paga, si aggiunge automaticamente al tuo credito. Il suo primo pagamento conta dopo {days} giorni, nel caso disdica subito dopo essersi abbonato.",
    whereQ: "Dove si usa il credito?",
    whereA: "Viene scalato automaticamente dalle tue prossime fatture WACheckin. Se non ti sei ancora abbonato, si applica alla tua prima fattura.",
    limitQ: "C'è un limite?",
    limitA: "Non c'è limite di inviti né di tempo. L'unico: il credito accumulato e non ancora usato arriva al massimo a {months} mesi del tuo piano. Finché sei a quel tetto il tuo piano resta gratis; quello che va oltre non si accumula.",
    stopQ: "Quando smetto di guadagnare?",
    stopA: "Se il tuo invitato disdice, smetti di guadagnare da lui. Se disdici tu, smetti di accumulare credito.",
    whoQ: "Chi posso invitare?",
    whoA: "Qualsiasi host o hotel che non usa ancora WACheckin. Autoinviti e account duplicati non sono idonei.",
  },
};
